import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ArticleColumn, ArticleEntryHeader, ArticleLeadImage } from "./article";
/**
 * Draw a page in its template's layout.
 *
 * ONE component, used by three surfaces that must agree: the public site, the
 * CMS canvas, and the CMS preview. Before this, layout came from the route tree
 * on the site and from nothing at all in the CMS, so an author composing a page
 * was looking at a shape no visitor would ever see. A layout that only the
 * website honours is a layout the Editor cannot work with.
 *
 * The presets are code, not content. An Editor chooses between them; nobody
 * authors one. Adding a layout means adding a case here AND a member of
 * TemplateLayout in @diality/contracts — the union is what stops a page naming
 * a layout that has no shape.
 *
 * `entry` is the article masthead's content, which arrives with Collections.
 * Until then it is absent everywhere, and every part that needs it renders
 * nothing rather than an empty frame.
 */
export function PageLayout({ layout, entry, backHref, wrapMasthead, children, }) {
    if (layout === "article") {
        const masthead = entry ? (_jsxs(_Fragment, { children: [_jsx(ArticleEntryHeader, { data: entry, backHref: backHref }), _jsx(ArticleLeadImage, { article: entry })] })) : null;
        return (_jsxs("div", { className: "@container w-full", children: [masthead && (wrapMasthead ? wrapMasthead(masthead) : masthead), _jsx(ArticleColumn, { entry: entry, children: children })] }));
    }
    // full-width: a passthrough, deliberately. Every block already declares its
    // own container and gutters, so a wrapper here would double them — this
    // layout is the absence of a layout, and it has to render as one.
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=page-layout.js.map